import _ = require("underscore");
import { LayerSwitcher } from "ol3-layerswitcher/index";
import Utils = require("../utils");
import Base = require("./base-command");

class Command extends Base<any> {
  static about = `
Wrapper for the ol3-layerswitcher control.
    `;

  static options = {
    "control-mid": {
      about: "used to override the default control (ol3-layerswitcher)"
    }
  };

  execute(args = this.args) {
    let options = _.defaults(this.options);

    Utils.withModule(LayerSwitcher, options["control-mid"], Control => {
      this.mediator.mapViewMap(map => {
        let switcher = new Control({
          tipLabel: Utils.translate(this.configuration.text)
        });

        this.mediator.mapView(mapView => {
          mapView.addControl(switcher);
          this.trigger({ switcher: switcher });
        });
      });
    });
  }
}

export = Command;
